import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { Collapse } from "react-collapse";
import "./FireOrigin.css";
import { ConfigProvider, TimePicker } from "antd";
import frFR from "antd/es/locale/fr_FR";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";

import "react-datepicker/dist/react-datepicker.css";

registerLocale("fr", fr);
dayjs.locale("fr");
const FireOrigin = ({
  openSection,
  dfciCode,
  setDfciCode,
  toggleFirstSection,
  formattedCurrentDate,
  formattedCurrentTime,
  onChangeOriginFireRef,
  onChangeOriginFireDate,
  onChangeOriginFireHour,
  onChangeOriginFireLocation,
  originFireRef,
  originFireDate,
  originFireHour,
  originFireLocation,
  operationId,
  triggerTooltip,
  getPoints,
  validateFirstSection,
  geocoderContainerRefSidebar,
}) => {
  useEffect(() => {
    if (!originFireDate) {
      onChangeOriginFireDate(formattedCurrentDate);
    }
    /*   if (!originFireHour) {
      onChangeOriginFireHour(formattedCurrentTime);
    } */
  }, [
    formattedCurrentDate,
    formattedCurrentTime,
    originFireDate,
    originFireHour,
    onChangeOriginFireDate,
    //onChangeOriginFireHour,
  ]);

  const handleDfciInputChange = (e) => {
    setDfciCode(e.target.value);
  };
  const handleOriginFireDateChange = (date) => {
    if (date) {
      const formatted = date.toISOString().split("T")[0]; // Format as yyyy-mm-dd
      onChangeOriginFireDate(formatted);
    }
  };

  const handleOriginFireHourChange = (time) => {
    if (time) {
      const formattedTime = time.format("HH:mm");
      onChangeOriginFireHour(formattedTime);
    }
  };
  const handleOriginFireRefChange = (e) => {
    onChangeOriginFireRef(e.target.value); // Store the input as a string
  };
  const handleFormSubmit = (e) => {
    e.preventDefault(); // Prevent page reload
    if (!originFireRef) {
      triggerTooltip("Veuillez d'abord taper la référence du feu!");
      return;
    }
    if (!originFireDate) {
      triggerTooltip("Veuillez d'abord entrer la date de la première alerte!");
      return;
    }
    if (!originFireHour) {
      triggerTooltip("Veuillez d'abord entrer l'heure de la première alerte!");
      return;
    }
    const points = getPoints(); // Get drawn polygons
    if (!points || points.length === 0) {
      triggerTooltip("Veuillez d'abord placer l'origine du feu sur la carte!");
      return;
    }

    toggleFirstSection(); // Handle the toggle logic (check if toggleFirstSection is defined and works properly)
    validateFirstSection();
  };

  const currentDate = new Date();

  const minDate = new Date(currentDate.getFullYear(), 6, 1); // month index 6 = July

  // Calculate the date 24 hours from now
  const maxDate = new Date(currentDate);

  return (
    <div>
      <Collapse isOpened={openSection === "origin"}>
        <Form className="form" onSubmit={handleFormSubmit} autoComplete="off">
          <Form.Group className="form-group-custom">
            <Form.Label>
              Référence
              <b style={{ color: "red", fontSize: "16px" }}>&nbsp;*</b>
            </Form.Label>
            <Form.Control
              className="form-control-own"
              type="text"
              placeholder="Entrer le  nom du feu"
              value={originFireRef || ""}
              onChange={handleOriginFireRefChange}
              data-testid="create-event-reference-input"
            />
          </Form.Group>
          <Form.Group className="form-group-custom">
            <Form.Label>
              Date de la première alerte
              <b style={{ color: "red", fontSize: "16px" }}>&nbsp;*</b>
            </Form.Label>
            <DatePicker
              selected={originFireDate}
              locale="fr"
              className="date-input"
              dateFormat="dd/MM/yyyy"
              value={originFireDate || formattedCurrentDate}
              onChange={handleOriginFireDateChange}
              minDate={minDate}
              maxDate={maxDate}
              data-testid="create-event-date-input"
            />
          </Form.Group>
          <Form.Group className="form-group-custom">
            <Form.Label>
              Heure de la première alerte
              <b style={{ color: "red", fontSize: "16px" }}>&nbsp;*</b>
            </Form.Label>

            <ConfigProvider locale={frFR}>
              <TimePicker
                className="time-input"
                style={{ width: "100%", height: "30px" }}
                format="HH:mm"
                placeholder="Sélectionnez l'heure"
                value={originFireHour ? dayjs(originFireHour, "HH:mm") : null}
                onSelect={handleOriginFireHourChange}
                data-testid="create-event-time-input"
              />
            </ConfigProvider>
          </Form.Group>
          <div className="localisation-div">
            <p className="localisation-title">Localisation</p>
            <div className="localisation-inputs-div">
              <Form.Group className="form-group-custom-two">
                <Form.Label>Adresse</Form.Label>
                <div className="sidebar-geocoder">
                  <div
                    ref={geocoderContainerRefSidebar}
                    className="geocoder-container"
                    value={originFireLocation}
                    // onChange={handleOriginFireLocationChange}
                    data-testid="create-event-address-input"
                  />
                </div>
              </Form.Group>
              <Form.Group className="form-group-custom-two">
                <Form.Label>Code DFCI</Form.Label>
                <Form.Control
                  className="form-control-own-two"
                  type="text"
                  placeholder="Code DFCI"
                  value={dfciCode}
                  onChange={handleDfciInputChange}
                  data-testid="create-event-dfci-code-input"
                />
              </Form.Group>
            </div>
          </div>
          <p className="note-origin">
            Positionnez l'origine du feu sur la carte !
          </p>
          <Button
            type="submit"
            className="event-btn sidebar-primary-btn"
            data-testid="create-event-validate-button"
          >
            Valider
          </Button>
        </Form>
      </Collapse>
    </div>
  );
};

export default React.memo(FireOrigin);
